module.exports = __webpack_public_path__ + "img/404.04102ecc.svg";